import { Div } from "atomize"
import NotebookContainer from "../notebook/NotebookContainer"

const Notebook = () => {
	return (
		<Div>
			<NotebookContainer />
			<Div h="10.75rem" pos="relative" />
		</Div>
	)
}

export default Notebook
